import { render, staticRenderFns } from "./RoomMiniBar.vue?vue&type=template&id=78e8e2c2&scoped=true"
import script from "./RoomMiniBar.vue?vue&type=script&lang=js"
export * from "./RoomMiniBar.vue?vue&type=script&lang=js"
import style0 from "./RoomMiniBar.vue?vue&type=style&index=0&id=78e8e2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e8e2c2",
  null
  
)

export default component.exports